import api from './api'

const loadNfcTagsForCurrentUser = (): Promise<Array<{ id: string; comment: string }>> =>
    api<Array<{ id: string; comment: string }>>({ path: '/users/nfctags/own' })

export default loadNfcTagsForCurrentUser
